import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

class CKeditor extends React.Component {
	constructor(props) {	
		super(props);
		
		this.state = {
			// Bytt mellom textarea virker ikke. TEkst blir ikke oppdatert.
			instance:false,
		}

		this.renderEditor = this.renderEditor.bind(this);
	}

	componentDidMount() {
		this.renderEditor();
	}

	onChange(v) {
    	this.props.change(v);
    }

    componentWillReceiveProps(next) {
		if(next.component != this.props.component) {
			this.state.instance.destroy();
		}
	}

	componentWillUnmount() {
		this.state.instance.destroy();
	}


	componentDidUpdate() {
		//this.renderEditor();
	}

	renderEditor() {
    	if(this.state.instance !== false) {
    		this.state.instance.destroy();
    		this.state.instance = false;
       	}


    	this.state.instance = CKEDITOR.replace(this.refs.editor, {
			customConfig:'/assets/js/ckeditor//editorConfig.js',
			width: '100%',
			height: '100%',
			on: {
		        change: ( evt ) => {
					this.onChange(this.state.instance.getData());
		        }
		    }
		});  
    }

	

    render() {
    	return <div ref="editor" dangerouslySetInnerHTML={{__html:this.props.html}} />
    }
}

const mapStateToProps = (state) => {
	return {
		builderPopup:state.builderPopup
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}

CKeditor = connect(mapStateToProps,mapDispatchToProps)(CKeditor);

export default CKeditor;





// WEBPACK FOOTER //
// ./components/CKeditor.js